<div class="userSettings-loading-message" *ngIf="!ready" fxFlexFill>Loading...</div>
<div
  *ngIf="ready"
  [nativeDesktopStyle]="{ 'height' : '80px' }"
  class="user-settings-component-container"
>
  <div class="user-settings-component-container" fxLayout="column">
    <div class="user-settings-control-row">
      <div class="row-content" fxflex="70%" fxlayout="column">
        <span
          [ngClass]="{'disabled': externalColours === false}"
          class="user-settings-control-row_title"
        >
          Enable External Group Column Colours</span
        >
        <p class="user-settings-control-row_description">
          Enables a different colour palette for External trader groups in BM Summary to distinguish
          them from Internal groups.
        </p>
      </div>
      <div class="setting_toggle" fxFlex="30%">
        <bfx-toggle [checked]="externalColours" (change)="enableExternalColoursToggle($event)">
        </bfx-toggle>
      </div>
    </div>

    <div class="user-settings-control-row" fxLayout="row">
      <div class="row-content" fxflex="70%" fxlayout="column">
        <span class="user-settings-control-row_title">Fixing Display Time Zone</span>
        <p class="user-settings-control-row_description">
          The Active and Recent Fixing times will be shown in this time zone
        </p>
      </div>
      <div class="row-content newOrderTypeDefault" fxFlex="30%" fxLayout="column">
        <div class="user-settings-control right">
          <bfx-autoComplete
            [title]="timezoneId?.label??''"
            #newOrderTypeDefaultSelection
            appendTo="body"
            size="sm"
            [(ngModel)]="timezoneId"
            [suggestions]="timezoneSuggestions"
            (completeMethod)="searchTimezones($event)"
            [dropdown]="true"
            (onBlur)="onBlurTz()"
            (onSelect)="onSelectTz()"
            (onFocus)="$event.target.select()"
            field="label"
            dataKey="id"
            [maxlength]="50"
            [allowEmptySelection]="false"
            [settingsCorrection]="true"
            [skipSorting]="true"
          ></bfx-autoComplete>
        </div>
      </div>
    </div>
  </div>
</div>
